"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _avatar = require("../../avatar");

var _AvatarImage = _interopRequireDefault(require("../../avatar/AvatarImage"));

var _AvatarName = _interopRequireDefault(require("../../avatar/AvatarName"));

var _avatarConstants = require("../../avatar/avatarConstants");

var _utils = require("../../avatar/utils");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _screenReaderOnly = require("../../screen-reader-only");

var _text = require("../../text");

var _utils2 = require("../../utils");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _ChipDismissButton = _interopRequireDefault(require("./ChipDismissButton"));

var _constants2 = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

var _excluded = ["avatar", "backgroundColor", "dismissButtonAltText", "dismissButtonRef", "children", "colorScheme", "icon", "iconPosition", "onDismiss", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var StaticChip = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var _avatar$showFullName;

  var avatar = _ref.avatar,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? _interfaces.ChipBackgroundColor.Default : _ref$backgroundColor,
      _ref$dismissButtonAlt = _ref.dismissButtonAltText,
      dismissButtonAltText = _ref$dismissButtonAlt === void 0 ? _constants2.staticChipDefaultProps.dismissButtonAltText : _ref$dismissButtonAlt,
      dismissButtonRef = _ref.dismissButtonRef,
      children = _ref.children,
      colorScheme = _ref.colorScheme,
      icon = _ref.icon,
      iconPosition = _ref.iconPosition,
      onDismiss = _ref.onDismiss,
      size = _ref.size,
      forwardedProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var chipId = (0, _react.useMemo)(function () {
    return "chip-".concat((0, _utils2.getUniqueId)(), "-id");
  }, []);
  var isDismissible = typeof onDismiss === 'function';
  var isDefaultSize = size === _interfaces.ChipSize.Default;
  var avatarSize = !isDefaultSize ? _avatar.AvatarSize.ExtraSmall : _avatar.AvatarSize.Small;
  var avatarShowFullName = (_avatar$showFullName = avatar === null || avatar === void 0 ? void 0 : avatar.showFullName) !== null && _avatar$showFullName !== void 0 ? _avatar$showFullName : true;
  var fontSize = isDefaultSize ? _constants.FONT_SIZE : _constants.FONT_SIZE_SMALL;

  var renderAvatarName = function renderAvatarName() {
    return avatarShowFullName ? (0, _core.jsx)(_AvatarName.default, {
      fullName: avatar === null || avatar === void 0 ? void 0 : avatar.fullName,
      showFullName: avatarShowFullName,
      colorScheme: colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _avatar.AvatarColorScheme.Inverted : _avatar.AvatarColorScheme.Default,
      fontSize: fontSize,
      fontWeight: "regular",
      lineHeight: _avatarConstants.layoutConstants[avatarSize].lineHeight,
      id: chipId
    }) : (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, {
      id: chipId
    }, avatar === null || avatar === void 0 ? void 0 : avatar.fullName);
  };

  return (0, _core.jsx)(_helperComponents.StaticChipContainer, (0, _extends2.default)({
    backgroundColor: backgroundColor,
    colorScheme: colorScheme,
    hasAvatar: !!avatar,
    ref: ref,
    size: size,
    isDismissible: isDismissible
  }, forwardedProps), avatar ? (0, _core.jsx)(_AvatarImage.default, {
    borderRadius: _avatarConstants.layoutConstants[avatarSize].borderRadius,
    shouldAnnounceImageAltText: false,
    size: _avatarConstants.layoutConstants[avatarSize].imageSize,
    source: (0, _utils.buildBadgeImageUrl)(avatar.username)
  }) : !!icon && iconPosition === _interfaces.ChipIconPosition.Leading && /*#__PURE__*/_react.default.cloneElement(icon, {
    color: _constants.ICON_COLOR[colorScheme][backgroundColor],
    size: _icons.IconSize.ExtraSmall
  }), (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    gridGap: _constants2.AVATAR_USERNAME_GAP
  }, avatar ? renderAvatarName() : (0, _core.jsx)(_text.Text, {
    fontSize: fontSize,
    id: isDismissible ? chipId : undefined
  }, children), avatar && (0, _core.jsx)(_avatar.AvatarUsername, {
    id: chipId,
    username: avatar.username,
    fontSize: fontSize,
    isUsernameClickable: avatar.isUsernameClickable !== undefined ? avatar.isUsernameClickable : true,
    newTabHiddenText: avatar.newTabHiddenText || _avatarConstants.AvatarDefaultProps.newTabHiddenText,
    colorScheme: colorScheme === _interfaces.ChipColorScheme.DarkBackground ? _avatar.AvatarColorScheme.Inverted : _avatar.AvatarColorScheme.Default,
    renderLink: _avatar.defaultRenderLink,
    lineHeight: _avatarConstants.layoutConstants[avatarSize].lineHeight,
    fontWeight: _avatarConstants.layoutConstants[avatarSize].nameFontWeight
  })), !avatar && !isDismissible && iconPosition === _interfaces.ChipIconPosition.Trailing && icon, isDismissible && (0, _core.jsx)(_ChipDismissButton.default, {
    chipId: avatar && avatarShowFullName ? "".concat(_avatarConstants.COMPONENT_FULL_NAME_ID, "-").concat(chipId) : chipId,
    colorScheme: colorScheme,
    dismissButtonAltText: dismissButtonAltText,
    dismissButtonRef: dismissButtonRef,
    backgroundColor: backgroundColor,
    onDismiss: onDismiss,
    size: size
  }));
});
var _default = StaticChip;
exports.default = _default;